<h1>Admin</h1>

@if (fullAdmin) {
<section>
    <p class="menu-item"><mat-icon>subscriptions</mat-icon><a href="/dealer-status">Dealer Subscriptions</a></p>
    <p class="menu-item"><mat-icon>subscriptions</mat-icon><a href="/fleet-status">Fleet Subscriptions</a></p>
    <p class="menu-item"><mat-icon>price_change</mat-icon><a href="/tiers">Manage Prices</a></p>
    <p class="menu-item"><mat-icon>person_add</mat-icon><a href="/fleet-customer">Create Fleet Customer</a></p>
    <p class="menu-item"><mat-icon>account_circle</mat-icon><a href="/account-info">Account Info</a></p>
</section>

<section>
    <h2>Reports</h2>
    <!-- <p class="menu-item"><mat-icon>pivot_table_chart</mat-icon><a href="/report-enrolled">Dealers</a></p> -->
    <!-- <p class="menu-item"><mat-icon>pivot_table_chart</mat-icon><a href="/report-enrolled?enrolled=U">Unenrolled Dealers</a></p> -->
    <p class="menu-item">
        <mat-icon>pivot_table_chart</mat-icon>
        <a href="/potential-billing-report">
            Current Billing Eligibility Report
        </a>
    </p>    
    <p class="menu-item"><mat-icon>pivot_table_chart</mat-icon><a href="/billing-report">Historical Monthly Billing Report</a></p>
    <p class="menu-item"><mat-icon>monetization_on</mat-icon><a href="/report-monthly-revenue">Monthly Revenue</a></p>
    <p class="menu-item"><mat-icon>format_list_numbered_rtl</mat-icon><a href="/report-tiers">Number of Dealers in
            Tiers</a></p>
</section>
}

<section>
    <h2>International Subscriptions</h2>
    <p class="menu-item"><mat-icon>subscriptions</mat-icon><a href="/dealer-status">Dealer Subscriptions</a></p>
    <p class="menu-item"><mat-icon>approval</mat-icon><a href="/request-intl">License Requests</a></p>
</section>

<section>
    <p>
        <button class="logout-btn" (click)="logOut()">
            <mat-icon>logout</mat-icon>
            Log Out
        </button>
    </p>
</section>